const calculator = {
  calculator: {
    pageTitle: 'Calculator',
    pageDescription: 'Easily calculate your estimated usage fees in USD and KRW based on per-minute rates.',

    label: {
      currency: 'Currency',
      planType: 'Plan Type',
      pricePerMin: 'Price per minute',
      usagePeriod: 'Usage Period (minutes)',
      totalEstimatedCost: 'Total Estimated Cost'
    },

    button: {
      moreInfo: 'For more information click here',
      reset: 'Reset'
    },

    plan: {
      pass: 'PASS'
    },

    country: {
      1: 'South Korea',
      2: 'Country 2',
      3: 'Country 3',
      4: 'Country 4'
    },

    currency: {
      1: 'KRW',
      2: 'USD'
    },

    perMinute: {
      1: '$13',
      2: '$15',
      3: '$17',
      4: '$19'
    }
  }
};

export default calculator;
